type NotificationTypeDict = Record<
  string,
  { label?: string; description?: string } | undefined
>;

type DomainDict = Record<string, string | undefined>;

export function resolveNotificationTypeLabel(
  typeId: string,
  fallback: string,
  typesDict?: NotificationTypeDict,
): string {
  return typesDict?.[typeId]?.label ?? fallback;
}

export function resolveNotificationTypeDescription(
  typeId: string,
  fallback: string,
  typesDict?: NotificationTypeDict,
): string {
  return typesDict?.[typeId]?.description ?? fallback;
}

export function resolveNotificationDomainLabel(
  domain: string,
  domainsDict?: DomainDict,
): string {
  return domainsDict?.[domain] ?? domain;
}

export const NOTIFICATION_DOMAIN_ORDER = ['leads', 'reputation'] as const;

export function sortDomainKeys(domains: string[]): string[] {
  const order = new Map(
    NOTIFICATION_DOMAIN_ORDER.map((domain, index) => [domain, index]),
  );
  return [...domains].sort((a, b) => {
    const aOrder = order.get(a as (typeof NOTIFICATION_DOMAIN_ORDER)[number]);
    const bOrder = order.get(b as (typeof NOTIFICATION_DOMAIN_ORDER)[number]);
    if (aOrder != null && bOrder != null) return aOrder - bOrder;
    if (aOrder != null) return -1;
    if (bOrder != null) return 1;
    return a.localeCompare(b);
  });
}
